"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureIndirectSubjectId;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ensureIdentity = _interopRequireDefault(require("./entity-helpers/ensureIdentity"));

var _createSubjectId = _interopRequireDefault(require("./createSubjectId"));

function ensureIndirectSubjectId(rule, subject) {
  return (0, _extends2.default)({}, subject, {
    id: (0, _createSubjectId.default)((0, _ensureIdentity.default)('entity', subject.product), rule.ruleCode)
  });
}